import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import User from "../interfaces/User";

export interface userState {
  user: User;
}

const initialState: userState = {
  user: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
    },
    setProfilePicture: (state, action: PayloadAction<string>) => {
      state.user.profileImage = action.payload;
    },
    setDisableUser: (state, action: PayloadAction<boolean>) => {
      state.user.disabled = action.payload;
    },
    resetUserState: () => initialState,
  },
});

export const { setUser, setProfilePicture, setDisableUser, resetUserState } =
  userSlice.actions;

export default userSlice.reducer;
